import React from 'react';
import PropTypes from 'prop-types';
import './RadioGroup.scss';

import { Root, Item, Indicator } from '@radix-ui/react-radio-group';

class RadioGroup extends React.Component {
	render() {
		const { name, defaultValue, value, options, onValueChange, centered, ariaLabel } = this.props;

		return (
			<Root
				name={name}
				className='RadioGroupRoot'
				defaultValue={defaultValue}
				aria-label={ariaLabel || 'Radio group options'}
				value={value}
				onValueChange={onValueChange}
				style={centered ? { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' } : {}}
			>
				{options.map((x) => {
					const id = `r1-${x.value}`;
					return (
						<div key={x.value} className='RadioGroupOption'>
							<Item className='RadioGroupItem' value={x.value} id={id} tabIndex={0}>
								<Indicator className='RadioGroupIndicator' />
							</Item>
							<label className='Label' htmlFor={id}>
								{x.label}
							</label>
						</div>
					);
				})}
			</Root>
		);
	}
}

RadioGroup.propTypes = {
	defaultValue: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	onValueChange: PropTypes.func.isRequired,
	centered: PropTypes.bool,
	ariaLabel: PropTypes.string,
	name: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any.isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
};

export default RadioGroup;
